export const PREP_REQUEST_FORM_LINK: string = "https://support.portal.flexport.com/hc/en-us/requests/new";
